


























import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import ProgressSpinner from "@/components/ui/ProgressSpinner.vue";

import { autofocusDirective } from "@/directives/autofocus.directive";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { AuthenticationCredentials } from "@/interfaces/authentication-credentials";

import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Authentication form
 */
@Component({
  components: { ProgressSpinner },
  directives: {
    ...autofocusDirective
  },
  mixins: [validationMixin],
  filters: {
    ...capitalizeFilter
  },
  validations: {
    login: {
      required
    },
    password: {
      required
    }
  }
})
export default class AuthenticationForm extends Vue {
  @Action("auth/authenticate") private authenticate!: (
    credentials: AuthenticationCredentials
  ) => void;
  @Getter("ui/isAnyAliasedRequestPending")
  private isAnyAliasedRequestPending!: (alias: string) => boolean;

  private login = "";
  private password = "";
  private requestAliasEnum = RequestAlias;

  i18nMessageKeyEnum = I18nMessageKey;

  /**
   * Authentication form submit method.
   * It emits authentication response if it was successful
   */
  submit(): void {
    const credentials: AuthenticationCredentials = {
      login: this.login,
      password: this.password
    };
    this.authenticate(credentials);
  }

  private get isLoading(): boolean {
    return this.isAnyAliasedRequestPending(this.requestAliasEnum.Authenticate);
  }
}
